import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'duration' })
export class DurationPipe implements PipeTransform {
    transform(date: any, charBetween: string): string {
        if (!date) { return '/'; }
        return moment(date).format('HH') + charBetween + moment(date).format('mm');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/pipes/duration-pipe.ts